import { useLang } from "@/contexts/LanguageContext";
import { t } from "@/translations";

export default function HeroSection() {
  const { lang } = useLang();
  const tr = t[lang].hero;

  return (
    <section
      className="relative w-full h-[420px] md:h-[520px] flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage:
          "url(https://fs-thb01.getcourse.ru/fileservice/file/thumbnail/h/9265fee3b9a16c7f90a8cb5a344e5fbc.jpg/s/s2000x/a/47075/sc/345)",
        backgroundSize: "cover",
        backgroundPosition: "center top",
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40" />
      <div className="relative z-10 text-center px-4">
        <h1 className="text-5xl md:text-7xl font-bold text-white tracking-widest uppercase">
          {tr.title}
        </h1>
      </div>
    </section>
  );
}
